export default "__VITE_ASSET__74b986d1__"